var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigateArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 69",
    style: {
      enableBackground: "new 0 0 68 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#223F7F;}\r\n\t.st1{fill:none;stroke:#F0F0F1;stroke-width:2;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,12.5L34.5,12.5c12.2,0,22,9.8,22,22l0,0c0,12.2-9.8,22-22,22l0,0c-12.2,0-22-9.8-22-22l0,0 C12.5,22.3,22.3,12.5,34.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.5,13.5L34.5,13.5c11.6,0,21,9.4,21,21l0,0c0,11.6-9.4,21-21,21l0,0c-11.6,0-21-9.4-21-21l0,0 C13.5,22.9,22.9,13.5,34.5,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.5,26.5l8,8l-8,8l-2-2l6-6l-6-6L31.5,26.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateArrow);
export default __webpack_public_path__ + "static/media/navigate-arrow.5732d179175fda53b010a2ff60d8e337.svg";
export { ForwardRef as ReactComponent };